'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstTabBar = function (_VstComponent) {
  _inherits(VstTabBar, _VstComponent);

  function VstTabBar() {
    _classCallCheck(this, VstTabBar);

    return _possibleConstructorReturn(this, (VstTabBar.__proto__ || Object.getPrototypeOf(VstTabBar)).apply(this, arguments));
  }

  _createClass(VstTabBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var maxIndex = this.props.children && this.props.children.length - 1;
      var children = _react2.default.Children.map(this.props.children, function (child, index) {
        return _react2.default.cloneElement(child, {
          active: index === _this2.props.activeIndex,
          onClick: function onClick() {
            return _this2.props.onClick(index);
          },
          onPreviousTab: index > 0 ? function () {
            return _this2.props.onClick(index - 1);
          } : function () {},
          onNextTab: index < maxIndex ? function () {
            return _this2.props.onClick(index + 1);
          } : function () {}
        });
      });
      var defaultClass = 'vst-tab-bar';
      var className = this.props.className ? defaultClass + ' ' + this.props.className : defaultClass;
      return _react2.default.createElement(
        'ul',
        { className: className, role: 'tablist' },
        children
      );
    }
  }]);

  return VstTabBar;
}(_VstComponent3.default);

exports.default = VstTabBar;


VstTabBar.defaultProps = {
  onClick: function onClick() {}
};


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTabBar.js
 **/